module.exports = __webpack_public_path__ + "static/media/2.47bc503d.jpg";